import styled, { css } from 'styled-components'

export const PriceElementPeriodUi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const PriceElementPeriodDescriptionUi = styled.div`
  width: 100%;
  padding-right: 10px;
  color: #181c39;
  font-weight: 600;
  font-size: 25px;
  line-height: 35px;
`

export const PriceElementPeriodTitle = styled.h1`
  margin-bottom: 65px;
  font-size: 80px;  
  font-weight: 600;
  color: #181c39;

  ${p => p.theme.phone} {
    font-size: 40px;
    margin-bottom: 30px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      font-size: 40px;
      margin-bottom: 30px;
  `}
`
